<template>
    <Layout>
        <PageHeader :items="items" :title="title"/>

        <div class="row">
            <div class="col-md-12">
                <b-card>
                    <router-link :to="{ name: 'sesDocumentCreate', params: { ses_id: ses_id } }"
                                 class="btn btn-success float-right btn-sm mb-1 text-black" title="Upload SES Document"
                                 tag="a">
                        <i class="mdi mdi-plus-box-outline addButton"></i> Upload Document
                    </router-link>
                    <div class="table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                            <tr>
                                <th>Sl</th>
                                <th>Category</th>
                                <th>Sub-category</th>
                                <th>Remark</th>
                                <th>File</th>
                                <th>Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr :key="index" v-for="(sesFile, index) in sesFiles">
                                <td>{{ index + 1 }}</td>
                                <td>{{ sesFile.category.desc }}</td>
                                <td>{{ sesFile.sub_category.desc }}</td>
                                <td>{{ sesFile.remarks }}</td>
                                <td>
                                    <a :href="sesFile.name" target="_blank">View</a>
                                </td>
                                <td>
                                    <router-link :to="{ name: 'sesDocumentUpdate', params: { ses_id: sesFile.id } }"
                                                 class="action-icon" title="Update SES Document"
                                                 tag="a">
                                        <i class="mdi mdi-square-edit-outline editButton"></i>
                                    </router-link>

                                    <a href="javascript:void(0);"
                                       class="action-icon" title="Delete SES Docs" @click="onDelete(sesFile.id, index)" >
                                        <i class="mdi mdi-delete deleteButton"></i>
                                    </a>

                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <h5 class="text-center text-secondary" v-if="sesFiles.length === 0">
                            No Data Found
                        </h5>
                    </div>
                </b-card>
            </div>
        </div>
    </Layout>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    export default {
        page: {
            title: "SES Document List",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader},
        data() {
            return {
                title: "SES Document List",
                items: [
                    {
                        text: "SES",
                        href: "ses/files"
                    },
                    {
                        text: "Dashboard",
                        active: true
                    }
                ],
                ses_id: "",
                sesFiles: [],
                validation_errors: {},
                show: false
            };
        },

        methods: {
            getSesFiles(ses_id) {
                http.get("api/ses/files/" + ses_id).then(response => {
                    this.sesFiles = response.data.data;
                });
            },
            onDelete(id, index) {
                if (confirm("Do you really want to delete?")) {
                    http.delete("api/ses/files/delete/" + id).then(response => {
                        this.sesFiles.splice(index, 1);
                        this.$bvToast.toast("Ses file deleted successfully", {
                            title: "Success",
                            autoHideDelay: 5000,
                            variant: "success"
                        });
                    });
                }
            },


        },

        mounted() {
            this.ses_id = this.$route.params.ses_id;
            this.getSesFiles(this.ses_id);
        }
    };
</script>
